// extracted by mini-css-extract-plugin
module.exports = {"animeArea":"AnimeArea-module--anime-area--36LXW"};